import React, {FunctionComponent, useState} from 'react';
import {ACard} from "@atiautomacao/ati-ui-library";

import {SimCardDownloadOutlined} from '@mui/icons-material';
import IconButton from "@mui/material/IconButton";
import {Box, Divider, Stack, TextField, Typography} from "@mui/material";

import ChartHeatmap from './ChartHeatmap';
import {AdapterDayjs} from '@mui/x-date-pickers/AdapterDayjs';
import {LocalizationProvider} from '@mui/x-date-pickers/LocalizationProvider';
import {DatePicker} from '@mui/x-date-pickers/DatePicker';
import {endOfDay, isWithinInterval, startOfDay} from 'date-fns';
import {LocalDateTimeFormatISO} from "../../../../Utils/DateFormatPatternUtils";
import {useAppSelector} from "../../../../Config/Hooks";

const PowerPUForInvertersChart: FunctionComponent<{skid: any;}> = ({skid}) => {
    const openSubMenu = useAppSelector((state: any) => state.layout.openSubMenu);
    const [date, setDate] = useState<Date | null>(startOfDay(new Date()));

    return (
        <ACard
            key={`chart-skid-pu-${openSubMenu}`}
            styleProps={{
                cardStyle: { height: 455,

                 },
                contentStyle: { padding: '0 16px', height: 284, justifyContent: 'left'},
                titleStyle: { alignItems: 'center', display: 'flex' },
                subTitleStyle: { display: 'none' },
                headerStyle: { flexDirection: 'row' },
                headerActionsStyle: { alignItems: 'center', display: 'flex'},

            }}
            headerControlsPosition={'header'}
            title={window.innerWidth < 550 ? "PU" : "Potência por inversor (PU)"}
            ariaLabel={"dashboard-skid-power-pu-chart"}
            headerActions={
                <Stack direction="column" spacing={"8px"}>
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0 12px' }}>
                        <IconButton disabled={true} size="small" sx={{borderRadius: '4px'}}>
                            <SimCardDownloadOutlined sx={{ marginRight: '12px' }} />
                            <Typography variant="body2">Baixar como CSV</Typography>
                        </IconButton>
                    </Box>
                    <Divider />
                    </Stack>
            }
            headerControls={
                <Stack direction="row" sx={{ alignItems: 'center', display: 'flex', padding: '8px' }}>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                            label="Dia"
                            renderInput={(params) => <TextField sx={{  '& .MuiOutlinedInput-root': 
                                { borderRadius: '8px', color: 'gray', height: '30px', width: '155px' } }} {...params} 
                            />}
                            value={date}
                            inputFormat={"DD/MM/YYYY"}
                            onChange={(newValue) => {
                                if (newValue && isWithinInterval(new Date(newValue), { start: new Date('1980-01-01'), end: endOfDay(new Date()) })) {
                                    setDate(startOfDay(new Date(LocalDateTimeFormatISO(newValue))));
                                }
                                return;
                            }}
                        />
                    </LocalizationProvider>
                </Stack>
            }
        >
            {skid && date &&
                <ChartHeatmap
                    skid={skid}
                    date={date}
                />
            }
        </ACard>
    )
}

export default PowerPUForInvertersChart;
